import React from 'react';
import {useAPI} from "../../../../lib/common";
import AppBar from "../../Components/AppBar";
import {Container} from "@material-ui/core";
import Slider from "./Components/Slider";
import PromoteCategory from "./Components/PromoteCategory";
import Module from "./Components/Module";
import Paragraph from "./Components/Paragraph";
import Title from "./Components/Title";
import RichText from "./Components/RichText";
import {useRouteMatch} from "react-router";
import {Trans} from "react-i18next";
import Image from "./Components/Image";


export default () => {
  const match = useRouteMatch();
  console.log('Route match is', match)
  return <LegacyPage id={match.params.id} />
}

export const StartPage = () => {
  return <LegacyPage id={'start-page'} />
}

export const LegacyPage = ({id}) => {
  const [pageData, loading] = useAPI(`/m/api/legacy-pages/${id}`)

  if (loading) {
    return <div>
    <AppBar />
      <Container>
        <Trans>Loading</Trans>
      </Container>
    </div>
  }

  if (!pageData) {
    return <div>
      <Trans>Page not found</Trans>
    </div>
  }

  return  <div>
    <AppBar />
      {pageData.modules.map((pageModule) => {
        switch (pageModule.type) {
          case "Slider":
            return <Module key={pageModule.id}>
                <Slider data={pageModule} />
            </Module>
          case "PromoteCategory":
            return <Module key={pageModule.id}>
              <PromoteCategory data={pageModule} />
            </Module>
          case "Title":
            console.log('Rendering heading', pageModule);
            return <Module key={pageModule.id}>
              <Title data={pageModule} />
            </Module>
          case "Paragraph":
            return <Module key={pageModule.id}>
              <Paragraph data={pageModule} />
            </Module>
          case "Image":
            return <Module key={pageModule.id}>
              <Image data={pageModule} />
            </Module>
          case "RichText":
            return <Module key={pageModule.id}>
              <RichText data={pageModule} />
            </Module>
        }
        console.log('Unknown module', pageModule);
        return <div>{pageModule.id}</div>
      })}
  </div>
}